<div id="container" *ngIf="Router.url !== '/' && Router.url !== '/home'">
    <button class="learn-more" (click)="back()">
      <span class="circle" aria-hidden="true">
        <span class="icon arrow"></span>
      </span>
      <span class="button-text">{{'back'|translate}}</span>
    </button>
  </div>

